
import request from '@/utils/request'
// 登录
export function login(data) {
  return request.post({
    url: '/employeeInformation/login',
    data: data
  })
}
// 分页查询产品数据
export function productData(data) {
  return request.post({
    url: '/productData/page',
    data: data
  })
}
// 保存产品基本信息
export function productDataSave(data) {
  return request.post({
    url: '/productData/saveProductDate',
    data: data
  })
}
// 删除产品
export function deleteProjectData(data) {
  return request.post({
    url: '/productData/deleteProjectData',
    data: data
  })
}
// 根据产品ID查看详情
export function projectDataInfo(data) {
  return request.post({
    url: '/productData/info',
    data: data
  })
}

// 删除文件
export function DeteteFile(data) {
  return request.post({
    url: '/file/delete',
    data: data
  })
}
// 文件下载
export function DownLoadFile(data) {
  return request.post({
    url: '/file/files',
    data: data
  })
}
// 员工信息
export function EmployeeInformation(data) {
  return request.post({
    url: '/employeeInformation/employeeList',
    data: data
  })
}
// 员工详细信息
export function employeeInformationInfo(data) {
  return request.post({
    url: '/employeeInformation/info',
    data: data
  })
}
// 员工保存
export function userSave(data) {
  return request.post({
    url: '/employeeInformation/saveInformation',
    data: data
  })
}
// 员工权限保存
export function userSavePermissions(data) {
  return request.post({
    url: '/employeeInformation/savePermissions',
    data: data
  })
}
// 员工权限根据id获取
export function userPermissionsGetById(data) {
  return request.post({
    url: '/employeePermission/getByEmployee',
    data: data
  })
}
// 员工权限全部获取
export function userAllPermissions(data) {
  return request.post({
    url: '/employeePermission/getAll',
    data: data
  })
}
// 删除员
export function DeleteUser(data) {
  return request.post({
    url: '/employeeInformation/delete',
    data: data
  })
}
// /employeeInformation/delete


// 部门列表
export function departmentList(data) {
  return request.post({
    url: '/department/page',
    data: data
  })
}
// 部门列表
export function allDepartmentList(data) {
  return request.post({
    url: '/department/infoDepartment',
    data: data
  })
}
// 部门保存
export function departmentSave(data) {
  return request.post({
    url: '/department/save',
    data: data
  })
}
// 删除部门
export function departmentDelete(data) {
  return request.post({
    url: '/department/delete',
    data: data
  })
}
// 全部部门
export function departmentAllList(data) {
  return request.post({
    url: '/department/departmentList',
    data: data
  })
}

// 客户管理
// 供应商列表
export function supplierList(data) {
  return request.post({
    url: '/supplier/page',
    data: data
  })
}
// 保存供应商
export function supplierSave(data) {
  return request.post({
    url: '/supplier/save',
    data: data
  })
}
// 删除供应商
export function supplierDelete(data) {
  return request.post({
    url: '/supplier/delete',
    data: data
  })
}
// 根据id获取单个供应商信息
export function supplierGetById(data) {
  return request.post({
    url: '/supplier/info',
    data: data
  })
}
// 供应商下拉列表
export function supplierSeleteList(data) {
  return request.post({
    url: '/supplier/selectOption',
    data: data
  })
}
// 客户列表
export function customerManagementList(data) {
  return request.post({
    url: '/customerManagement/page',
    data: data
  })
}
// 保存供客户
export function customerManagementSave(data) {
  return request.post({
    url: '/customerManagement/saves',
    data: data
  })
}
// 删除客户
export function customerManagementDelete(data) {
  return request.post({
    url: '/customerManagement/delete',
    data: data
  })
}
// 根据id获取单个客户信息
export function customerManagementGetById(data) {
  return request.post({
    url: '/customerManagement/info',
    data: data
  })
}

// 预算项目
// 保存预算项目
export function budgetItemsSave(data) {
  return request.post({
    url: '/budgetItems/save',
    data: data
  })
}
// 预算项目详情信息
export function budgetItemsInfo(data) {
  return request.post({
    url: '/budgetItems/info',
    data: data
  })
}
// 删除项目详情信息
export function budgetItemsDelete(data) {
  return request.post({
    url: '/budgetItems/delete',
    data: data
  })
}
// 全部预算项目
export function budgetItemsAllList(data) {
  return request.post({
    url: '/budgetItems/budgetItemList',
    data: data
  })
}


// 主要业务收入及成本预算
// 主要业务收入及成本预算列表查询
export function revenueCostBudgetList(data) {
  return request.post({
    url: '/revenueCostBudget/paymentBudgeList',
    data: data
  })
}
// 查询根据id查看主要业务收入及成本预算信息
export function revenueCostBudgetInfo(data) {
  return request.post({
    url: '/revenueCostBudget/info',
    data: data
  })
}
// 保存主要业务收入及成本预算信息
export function revenueCostBudgeSave(data) {
  return request.post({
    url: '/revenueCostBudget/saves',
    data: data
  })
}
// 根据id删除主要业务收入及成本预算
export function revenueCostBudgeDelete(data) {
  return request.post({
    url: '/revenueCostBudget/deleteCost',
    data: data
  })
}


// 查看项目收付款预算详情
// 主要业务收入及成本预算列表查询
export function collectionPaymentBudgetList(data) {
  return request.post({
    url: '/collectionPaymentBudget/paymentBudgeList',
    data: data
  })
}
// 查询根据id查看主要业务收入及成本预算信息
export function collectionPaymentBudgetInfo(data) {
  return request.post({
    url: '/collectionPaymentBudget/info',
    data: data
  })
}
// 保存主要业务收入及成本预算信息
export function collectionPaymentBudgetSave(data) {
  return request.post({
    url: '/collectionPaymentBudget/save',
    data: data
  })
}
// 根据id删除主要业务收入及成本预算
export function collectionPaymentBudgetDelete(data) {
  return request.post({
    url: '/collectionPaymentBudget/deleteBudget',
    data: data
  })
}

// 流程基本信息列表
export function processManageList(data) {
  return request.post({
    url: '/processManage/list',
    data: data
  })
}

// 保存流程基本信息
export function processManageSave(data) {
  return request.post({
    url: '/processManage/save',
    data: data
  })
}

// 删除流程
export function processManageDelete(data) {
  return request.post({
    url: '/processManage/delete',
    data: data
  })
}

// 项目管理列表
export function projectInfomationList(data) {
  return request.post({
    url: '/projectInformation/page',
    data: data
  })
}

// 项目管理保存
export function projectInfomationSave(data) {
  return request.post({
    url: '/projectInformation/saveProject',
    data: data
  })
}
// 项目管理详情
export function projectInfomationInfo(data) {
  return request.post({
    url: '/projectInformation/info',
    data: data
  })
}

// 项目管理结束
export function projectInfomationStop(data) {
  return request.post({
    url: '/projectInformation/selectStateStop',
    data: data
  })
}

// 项目管理删除
export function projectInfomationDelete(data) {
  return request.post({
    url: '/projectInformation/deleteProject',
    data: data
  })
}

// 项目管理优先级
export function projectInfomationTopUp(data) {
  return request.post({
    url: 'projectInformation/topUp',
    data: data
  })
}

// 根据关键字筛选产品库（下拉）
export function productDataSearch(data) {
  return request.post({
    url: '/productData/search',
    data: data
  })
}
// 价格对比
export function contrastPrice(data) {
  return request.post({
    url: '/purchaseProducts/checkPrice',
    data: data
  })
}
// 价格对比
export function formContracPrice(data) {
  return request.post({
    url: '/formContractProducts/checkPrice',
    data: data
  })
}
// 价格对比
export function formPurchaseApplyInfo(data) {
  return request.post({
    url: '/formPurchaseApply/getForm',
    data: data
  })
}
// 流程信息下拉选项
export function processManageSelect(data) {
  return request.post({
    url: '/processManage/selectOption',
    data: data
  })
}
// 项目信息下拉选项
export function projectInformationSelect(data) {
  return request.post({
    url: '/projectInformation/selectOption',
    data: data
  })
}
// 项目信息下拉选项
export function formPurchaseApplySave(data) {
  return request.post({
    url: '/formPurchaseApply/saveForm',
    data: data
  })
}
// 启动流程
export function processExecutionStart(data) {
  return request.post({
    url: '/processExecution/startProcess',
    data: data
  })
}
// 启动流程
export function formMarkOption(data) {
  return request.post({
    url: '/processManage/formMarkOption',
    data: data
  })
}

// 启动流程
export function myProjectsList(data) {
  return request.post({
    url: '/projectInformation/myProjects',
    data: data
  })
}
// 通过
export function processExecutionNext(data) {
  return request.post({
    url: '/processExecution/nextExe',
    data: data
  })
}
// 退回
export function processExecutionGoBack(data) {
  return request.post({
    url: '/processExecution/goBack',
    data: data
  })
}
// 撤回
export function processExecutionRecall(data) {
  return request.post({
    url: '/processExecution/recall',
    data: data
  })
}
// 流程执行情况图
export function processExecutionDiagram(data) {
  return request.post({
    url: '/processExecution/processDiagram',
    data: data
  })
}

// 项目详情
export function saveProjectTeam(data) {
  return request.post({
    url: '/projectTeam/saveProjectTeam',
    data: data
  })
}
export function removeProjectTeam(data) {
  return request.post({
    url: '/projectTeam/removeProjectTeam',
    data: data
  })
}
export function projectTeamList(data) {
  return request.post({
    url: '/projectTeam/projectTeamList',
    data: data
  })
}
// 系统下拉
export function selectOptionSystem(data) {
  return request.post({
    url: '/productData/selectOptionSystem',
    data: data
  })
}
// 头像下载
export function headPhoto(data) {
  return request.post({
    url: '/file/headPhoto',
    data: data
  })
}
// 资源库图片下载
export function prodataImage(data) {
  return request.post({
    url: '/file/prodataImage',
    data: data
  })
}
// 头像资源库图片上传
export function fileUpload(data) {
  return request.post({
    url: '/file/upload',
    data: data
  })
}
// 用印保存
export function saveFormPrint(data) {
  return request.post({
    url: '/formPrint/saveFormPrint',
    data: data
  })
}
// 用印详情
export function getFormPrint(data) {
  return request.post({
    url: '/formPrint/getFormPrint',
    data: data
  })
}
// 合同审批
export function saveFormApproval(data) {
  return request.post({
    url: '/formContractApproval/saveFormApproval',
    data: data
  })
}
// 查看合同审批详情
export function getFormApproval(data) {
  return request.post({
    url: '/formContractApproval/getFormApproval',
    data: data
  })
}
export function savePay(data) {
  return request.post({
    url: '/formPay/savePay',
    data: data
  })
}
export function getPay(data) {
  return request.post({
    url: '/formPay/getPay',
    data: data
  })
}
export function saveInvoic(data) {
  return request.post({
    url: '/formInvoic/saveInvoic',
    data: data
  })
}
export function getIvoic(data) {
  return request.post({
    url: '/formInvoic/getIvoic',
    data: data
  })
}

export function saveStatisticsAuth(data) {
  return request.post({
    url: '/employeeInformation/saveStatisticsAuth',
    data: data
  })
}

//

export function infoStagingAuthSelected(data) {
  return request.post({
    url: '/employeeInformation/infoStagingAuthSelected',
    data: data
  })
}

export function employeeInformationInfoAuth(data) {
  return request.post({
    url: '/employeeInformation/infoAuth',
    data: data
  })
}
// 添加进度顺序
export function saveOrder(data) {
  return request.post({
    url: '/processManage/saveOrder',
    data: data
  })
}
export function selectOrder(data) {
  return request.post({
    url: '/processManage/selectOrder',
    data: data
  })
}
export function processExecutionOrders(data) {
  return request.post({
    url: '/processManage/showOrder',
    data: data
  })
}
export function selectByOrder(data) {
  return request.post({
    url: '/processExecution/selectByOrder',
    data: data
  })
}
export function selectAddOption(data) {
  return request.post({
    url: '/processManage/selectAddOption',
    data: data
  })
}
export function projectInformationShowBank(data) {
  return request.post({
    url: '/projectInformation/showBank',
    data: data
  })
}

//报销单收款账户信息--根据登录人
export function employeeInformationSelectUserBank(data) {
  return request.post({
    url: '/employeeInformation/selectUserBank',
    data: data
  })
}

// 保存主要会议详情
export function saveSessionsMain(data) {
  return request.post({
    url: '/sessionsMain/saveSessionsMain',
    data: data
  })
}
// 根据会议顺序、项目id显示主要会议详情
export function byMeetingOrder(data) {
  return request.post({
    url: '/sessionsMain/byMeetingOrder',
    data: data
  })
}
// 删除主要会议
export function deleteSessionsMain(data) {
  return request.post({
    url: '/sessionsMain/deleteSessionsMain',
    data: data
  })
}
// 分页查询其他会议
export function sessionsOtherpage(data) {
  return request.post({
    url: '/sessionsOther/page',
    data: data
  })
}
// 其他会议
export function sessionsOtherinfoOther(data) {
  return request.post({
    url: '/sessionsOther/infoOther',
    data: data
  })
}
// 保存其他会议
export function sessionsOtherSaveProductDate(data) {
  return request.post({
    url: '/sessionsOther/saveProductDate',
    data: data
  })
}
// 删除其他会议
export function sessionsOtherDeleteSessionsOther(data) {
  return request.post({
    url: '/sessionsOther/deleteSessionsOther',
    data: data
  })
}


export function customerManagementSelectOption(data) {
  return request.post({
    url: '/customerManagement/selectOption',
    data: data
  })
}
export function saveBid(data) {
  return request.post({
    url: '/formBid/saveBid',
    data: data
  })
}
export function getBid(data) {
  return request.post({
    url: '/formBid/getBid',
    data: data
  })
}
// 根据当前登录人查询消息
export function listNotice(data) {
  return request.post({
    url: '/notice/listNotice',
    data: data
  })
}

export function savePlan(data) {
  return request.post({
    url: '/projectPlan/savePlan',
    data: data
  })
}
export function infoPlan(data) {
  return request.post({
    url: '/projectPlan/infoPlan',
    data: data
  })
}
export function deletePlan(data) {
  return request.post({
    url: '/projectPlan/deletePlan',
    data: data
  })
}
export function pagePlan(data) {
  return request.post({
    url: '/projectPlan/pagePlan',
    data: data
  })
}

export function pageDaily(data) {
  return request.post({
    url: '/projectDaily/pageDaily',
    data: data
  })
}
export function infoDaily(data) {
  return request.post({
    url: '/projectDaily/infoDaily',
    data: data
  })
}
export function saveDaily(data) {
  return request.post({
    url: '/projectDaily/saveDaily',
    data: data
  })
}
export function deleteDaily(data) {
  return request.post({
    url: '/projectDaily/deleteDaily',
    data: data
  })
}

export function infoNotice(data) {
  return request.post({
    url: '/notice/infoNotice',
    data: data
  })
}

//一键已读
export function updateNoticeState(data) {
  return request.post({
    url: '/notice/updateNoticeState',
    data: data
  })
}

export function unreadNotice(data) {
  return request.post({
    url: '/notice/unreadNotice',
    data: data
  })
}
export function exportPriceExcel(data) {
  return request.post({
    url: '/productData/exportPriceExcel',
    data: data
  })
}



//借款单申请
export function saveFormLoanBill(data) {
  return request.post({
    url: '/formLoanBill/saveFormLoanBill',
    data: data
  })
}

//借款单详情查询
export function getFormLoanBill(data) {
  return request.post({
    url: '/formLoanBill/getFormLoanBill',
    data: data
  })
}

//流程查询
export function starOption(data) {
  return request.post({
    url: '/processManage/starOption',
    data: data
  })
}

//合同List
export function showContract(data) {
  return request.post({
    url: '/projectInformation/showContract',
    data: data
  })
}

//合同List--用印
export function showContractByPrint(data) {
  return request.post({
    url: '/projectInformation/showContractByPrint',
    data: data
  })
}

//合同List  --开票专用
export function showContractBySale(data) {
  return request.post({
    url: '/projectInformation/showContractBySale',
    data: data
  })
}



//员工报销单申请
export function saveFormEmployeeReimbursement(data) {
  return request.post({
    url: '/formEmployeeReimbursement/saveFormEmployeeReimbursement',
    data: data
  })
}


//员工报销单详情
export function getFormEmployeeReimbursement(data) {
  return request.post({
    url: '/formEmployeeReimbursement/getFormEmployeeReimbursement',
    data: data
  })
}



//劳务费用发放单
export function savePaymentLabor(data) {
  return request.post({
    url: '/formPaymentLabor/savePaymentLabor',
    data: data
  })
}


//劳务费用发放单详情
export function getPaymentLabor(data) {
  return request.post({
    url: '/formPaymentLabor/getPaymentLabor',
    data: data
  })
}


//采购申请单
export function formPurchaseReSaveForm(data) {
  return request.post({
    url: '/formPurchaseRe/saveForm',
    data: data
  })
}


//采购申请单详情
export function formPurchaseReGetForm(data) {
  return request.post({
    url: '/formPurchaseRe/getForm',
    data: data
  })
}






/*
 *    导入导出模块
 */

// 导出主要会议模板
export function exportTemplateSessionsMain(data) {
  return request.post({
    url: '/sessionsMain/excelTemplate',
    data: data
  })
}
// 导出主要会议
export function exportExcelSessionsMain(data) {
  return request.post({
    url: '/sessionsMain/exportExcel',
    data: data
  })
}
// 导入主要会议信息
export function importExcelSessionsMain(data) {
  return request.post({
    url: '/sessionsMain/importExcel',
    data: data
  })
}

// 导出其他会议模板
export function exportTemplateSessionsOther(data) {
  return request.post({
    url: '/sessionsOther/excelTemplate',
    data: data
  })
}
// 导出其他会议
export function exportExcelSessionsOther(data) {
  return request.post({
    url: '/sessionsOther/exportExcel',
    data: data
  })
}
// 导入其他会议信息
export function importExcelSessionsOther(data) {
  return request.post({
    url: '/sessionsOther/importExcel',
    data: data
  })
}

// 导出项目日报模板
export function exportTemplateProjectDaily(data) {
  return request.post({
    url: '/projectDaily/excelTemplate',
    data: data
  })
}
// 导出项目日报
export function exportExcelProjectDaily(data) {
  return request.post({
    url: '/projectDaily/exportExcel',
    data: data
  })
}
// 导入项目日报信息
export function importExcelProjectDaily(data) {
  return request.post({
    url: '/projectDaily/importExcel',
    data: data
  })
}


//售前项目保存
export function preSalesSaveProject(data) {
  return request.post({
    url: '/saleProjectInformation/saveProject',
    data: data
  })
}


//售前项目删除  
export function preSalesSaveDeleteProjectt(data) {
  return request.post({
    url: '/saleProjectInformation/deleteProject',
    data: data
  })
}


//售前项目List   
export function preSalesSaveSelectSaleProject(data) {
  return request.post({
    url: '/saleProjectInformation/selectSaleProject',
    data: data
  })
}


//修改密码
export function savePassword(data) {
  return request.post({
    url: '/employeeInformation/savePassword',
    data: data
  })
}

// 根据项目ID获取权限
export function projectInfoAuth(data) {
  return request.post({
    url: '/projectAuth/infoAuth',
    data: data
  })
}

// 品牌下拉
export function selectProductBrand(data) {
  return request.post({
    url: '/productData/selectProductBrand',
    data: data
  })
}


// 项目列表导出
export function projectInformationExportExcel(data) {
  return request.post({
    url: '/projectInformation/exportExcel',
    data: data
  })
}






// 表单存草稿

//标书制作流程
export function formTemplateSaveBid(data) {
  return request.post({
    url: 'formTemplate/saveBid',
    data: data
  })
}

//用印流程
export function formTemplateSaveFormPrint(data) {
  return request.post({
    url: '/formTemplate/saveFormPrint',
    data: data
  })
}

//借款流程
export function formTemplateSaveFormLoanBill(data) {
  return request.post({
    url: '/formTemplate/saveFormLoanBill',
    data: data
  })
}

//采购流程
export function formTemplateSaveForm(data) {
  return request.post({
    url: '/formTemplate/saveForm',
    data: data
  })
}

//开票流程
export function formTemplateSaveInvoic(data) {
  return request.post({
    url: '/formTemplate/saveInvoic',
    data: data
  })
}

//劳务费用发放流程
export function formTemplateSavePaymentLabor(data) {
  return request.post({
    url: '/formTemplate/savePaymentLabor',
    data: data
  })
}

//付款流程
export function formTemplateSavePay(data) {
  return request.post({
    url: '/formTemplate/savePay',
    data: data
  })
}

//报销流程
export function formTemplateSaveFormEmployeeReimbursement(data) {
  return request.post({
    url: '/formTemplate/saveFormEmployeeReimbursement',
    data: data
  })
}

//合同审批流程
export function formTemplateSaveFormApproval(data) {
  return request.post({
    url: '/formTemplate/saveFormApproval',
    data: data
  })
}


//存草稿详情
export function formTemplateFormInfo(data) {
  return request.post({
    url: '/formTemplate/formInfo',
    data: data
  })
}


//存草稿删除
export function formTemplateFormDel(data) {
  return request.post({
    url: '/formTemplate/formDel',
    data: data
  })
}





// 付款单专用 -- 收款账户信息 
export function formPayListBank(data) {
  return request.post({
    url: '/formPay/listBank',
    data: data
  })
}




//项目收入、成本分类---数据列表
export function exportProjectRevenueCostList(data) {
  return request.post({
    url: '/departmentTemplate/exportProjectRevenueCostList',
    data: data
  })
}

//项目账龄分析---数据列表
export function agingAnalysisList(data) {
  return request.post({
    url: '/departmentTemplate/agingAnalysisList',
    data: data
  })
}


// 用车流程保存
export function saveFormCar(data) {
  return request.post({
    url: '/formCar/saveFormCar',
    data: data
  })
}

// 用车流程详情
export function getFormCar(data) {
  return request.post({
    url: '/formCar/getFormCar',
    data: data
  })
}


// 获取当月用车情况
export function getFormCarTime(data) {
  return request.post({
    url: 'formCar/formCarTime',
    data: data
  })
}